import React from 'react';
import { ButtonBase, Grid, Typography, Box } from '@material-ui/core';
import { ChevronLeft } from '@material-ui/icons';
import { TabletButton } from '@campfire/tablet-button/lib';
import { useFormikContext } from 'formik';
import { useHistory } from 'react-router';
import { useCampfireTheme } from '../../../../theme/useCampfireTheme';

interface Props {
  formName: string;
  disabled?: boolean;
}

export const FormBuilderHeader = (props: Props) => {
  const { formName, disabled = false } = props;
  const { submitForm, resetForm, initialValues, values } = useFormikContext();
  const history = useHistory();

  const { theme, isMobile } = useCampfireTheme();

  return (
    <Box>
      <Grid container alignItems='center' spacing={isMobile ? 1 : 2} style={{ padding: 8 }}>
        <Grid item xs>
          <ButtonBase disableRipple onClick={() => history.goBack()}>
            <Grid container style={{ paddingLeft: isMobile ? 0 : 16 }}>
              <ChevronLeft style={{ color: theme.palette.text.secondary }} />
              <Typography color='textSecondary' noWrap style={{ maxWidth: isMobile ? '160px' : 'auto' }}>
                {formName}
              </Typography>
            </Grid>
          </ButtonBase>
        </Grid>
        <Grid item>
          <Box
            style={{
              fontSize: '0.75rem',
              fontWeight: 600,
              padding: 8,
              paddingLeft: 12,
              paddingRight: 12,
              borderRadius: 4,
              backgroundColor: '#E8F5E9',
              color: '#2E7D32',
              marginRight: 8,
            }}
          >
            Form
          </Box>
        </Grid>
        <Grid item>
          <TabletButton onClick={() => resetForm()} disabled={disabled || initialValues === values}>
            {isMobile ? 'Discard' : 'Discard changes'}
          </TabletButton>
        </Grid>
        <Grid item>
          <TabletButton color='primary' variant='contained' onClick={() => submitForm()} disabled={disabled}>
            {isMobile ? 'Save' : 'Save changes'}
          </TabletButton>
        </Grid>
      </Grid>
    </Box>
  );
};
